export enum Variant {
  SMALL = 'small',
  NORMAL = 'normal',
  MEDIUM = 'medium',
  LARGE = 'large',
  XL = 'xl',
  XXL = 'xxl',
  HUGE = 'huge',
}
